import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Box from '@tds/core-box';
import Text from '@tds/core-text';
import EN from '../../EN.json';
import FR from '../../FR.json';
import { useLocaleContext } from '../context/LocaleContext';
import { Button } from '../design/css';
import moment from 'moment';

const ViewOrderHeader = ({ orderData }) => {
  const locale = useLocaleContext();
  //All lables are fetched from EN.json and FR.json
  const {
    ORDERS: {
      orderId,
      businessName,
      channel,
      createdBy,
      createdAt,
      submittedDate,
      channelTicketNumber,
      spocTicketNumber,
      statusText
    },
    DEFECT_MANAGEMENT: { STATUS },
    formStep: { mssDefect }
  } = locale === 'en-US' ? EN : FR;
  const {
    orderId: orderIdvalue,
    wlsBusinessLegalName,
    channel:orderChannel ,
    orderCreatedBy: { email },
    createdAt: createdAtValue,
    validatedAt: validatedAtValue,
    channelTicketNumber: channelTicketNumberValue,
    spocTicketNumber: spocTicketNumberValue,
    status: statusValue,
    reasonForSubmission,
    mssDefectTeam
  } = orderData;

  const getButton = (onClick, label, isDisabled) => (
    <Button onClick={onClick} disabled={isDisabled}>
      {label}
    </Button>
  );

  return (
    <Fragment>
      <Box pb={12}>
        <Text bold color="#4B286D">
          {orderId}:{' '}
        </Text>
        <Text>{orderIdvalue}</Text>
      </Box>
      <Box pb={12}>
        <Text bold color="#4B286D">
          {businessName}:{' '}
        </Text>
        <Text>{wlsBusinessLegalName}</Text>
      </Box>
      {
        orderChannel && orderChannel.description && (
          <Box pb={12}>
        <Text bold color="#4B286D">
          {channel}:{' '}
        </Text>
        <Text>{orderChannel.description}</Text>
      </Box>
        )
      }
      
      <Box>
        <Text bold color="#4B286D">
          {createdBy}:{' '}
        </Text>
        <Text>{email} </Text>
      </Box>
      <Box>
        <Text bold color="#4B286D">
          {createdAt}:{' '}
        </Text>
        <Text>
          {moment.utc(createdAtValue).format('dddd, MMMM Do YYYY, h:mm:ss a') +
            ' UTC'}
        </Text>
      </Box>
      {validatedAtValue && (
        <Box>
          <Text bold color="#4B286D">
            {submittedDate}:{' '}
          </Text>
          <Text>
            {moment
              .utc(validatedAtValue)
              .format('dddd, MMMM Do YYYY, h:mm:ss a') + ' UTC'}
          </Text>
        </Box>
      )}
      <Box>
        <Text bold color="#4B286D">
          {STATUS}:{' '}
        </Text>
        <Text>{statusText[statusValue]}</Text>
      </Box>
      {reasonForSubmission === mssDefect && mssDefectTeam === 'SMB Sales' && (
        <Box>
          <Text bold color="#4B286D">
            {channelTicketNumber}:{' '}
          </Text>
          <Text>{channelTicketNumberValue}</Text>
        </Box>
      )}
      {reasonForSubmission === mssDefect && mssDefectTeam === 'BCX Care' && (
        <Box>
          <Text bold color="#4B286D">
            {spocTicketNumber}:{' '}
          </Text>
          <Text>{spocTicketNumberValue}</Text>
        </Box>
      )}
    </Fragment>
  );
};

ViewOrderHeader.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired
};

export default ViewOrderHeader;
